import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import Icon from '../../../../../components/Icon/Icon';
import arrow from '../../../../../assets/images/hero-arrow.png';
import imgHero from '../i/bg-our-food-dt.jpg';
import imgHeroMobile from '../i/bg-our-food-mobile.jpg';
import imgOurBeef from '../i/our-beef.jpg';
import imgOurPork from '../i/our-pork.jpg';
import imgOurBeyondMeat from '../i/our-beyondmeat.jpg';
import imgOurProteinsDesk from '../i/bg-proteins_dt.jpg';
import imgOurProduceDesk from '../i/bg-produce_dt.jpg';
import imgOurDrinksDesk from '../i/bg-drinks_dt.jpg';
import imgOurTomatoes from '../i/our-tomatoes.jpg';
import imgOurOnions from '../i/our-onions.jpg';
import imgOurLettuce from '../i/our-lettuce.jpg';
import imgOurCheese from '../i/our-cheese.jpg';
import imgOurRootBeer from '../i/our-rootbeer.jpg';
import imgOurCoffee from '../i/our-coffee.jpg';

import imgAnimalWelfare from '../i/bg-animalwelfare_mb.jpg';
import imgAnimalWelfareDesk from '../i/bg-animalwelfare_dt.jpg';
import imgOurChicken from '../i/our-chicken.jpg';
import imgOurEggs from '../i/our-eggs.jpg';

const Desktop = (props) => {
    // UseState
    const [fadeLayer, setFadeLayer] = useState(false);
    const [isProtein, setIsProtein] = useState(false);
    const [isProduce, setIsProduce] = useState(false);
    const [isDrinks, setIsDrinks]   = useState(false);
    const [isAnimalWelfare, setIsAnimalWelfare] = useState(false);
    const [currentHeight, setCurrentHeight] = useState(0);
    

    // UseRef
    const refProtein1 = useRef();
    const refProtein2 = useRef();
    const refProduce = useRef();
    const refDrinks  = useRef();
    const foodOptions = useRef();

    useEffect(() => {
        if(fadeLayer){
            foodOptions.current.scrollIntoView()
        }
    }, [fadeLayer]);


    const handleOptionClick = (option) => {
        if (option === 'protein'){
            setIsProtein(prevState => !prevState);
            setCurrentHeight(refProtein1.current.clientHeight + refProtein1.current.clientHeight)
            setIsProduce(false);
            setIsDrinks(false);
            setIsAnimalWelfare(false);
        }
        if (option === 'produce'){
            setIsProtein(false);
            setIsProduce(prevState => !prevState);
            setCurrentHeight(refProduce.current.clientHeight)
            setIsDrinks(false);
            setIsAnimalWelfare(false);
        }
        if (option === 'drinks'){
            setIsProtein(false);
            setIsProduce(false);
            setIsDrinks(prevState => !prevState);
            setCurrentHeight(refDrinks.current.clientHeight)
            setIsAnimalWelfare(false);
        }
       
        if (option === 'animal'){
            setIsProtein(false);
            setIsProduce(false);
            setIsDrinks(false);
            setIsAnimalWelfare(prevState => !prevState);
        }


        setFadeLayer(prevState => !prevState);
    }

    return (
        <>
            <div className="blockwrap our-food-pages home-our-food">
                <div className={`fade-layer ${fadeLayer && 'fade-on'}`}></div>
                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="" />
                    }
                </div>

                <div className="copy-block">
                 
                    {props.lang === 'en' && <h1><span><span className="line"></span> Our <span className="line"></span></span>Food</h1> }
                    {props.lang === 'fr' && <h1><span><span className="line"></span> Nos <span className="line"></span></span>INGRÉDIENTS</h1> }
                    {props.lang === 'en' && <p>We’re on a journey to source simple, great-tasting ingredients farmed with care.</p>}
                    {props.lang === 'fr' && <p>Nous nous sommes donné comme mission de vous offrir des ingrédients de premier choix, produits de la meilleure manière qui soit.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="blockwrap our-food-pages options-wrap">

                <button className={`ingredient-option ${isProtein && 'is-active'}`} onClick={() => handleOptionClick('protein')} disabled={fadeLayer && !isProtein ? true : false}>
                    <div className={`fade-layer ${fadeLayer && 'fade-on'}`}></div>
                    <h2>{props.lang !== 'fr' ? 'Proteins' : 'Protéines'} <Icon type="plus-inverted" /></h2>
                    <img src={imgOurProteinsDesk} alt="background protein" /> 
                </button>

                <button className={`ingredient-option ${isProduce && 'is-active'}`} onClick={() => handleOptionClick('produce')} disabled={fadeLayer && !isProduce ? true : false}>
                    <div className={`fade-layer ${fadeLayer && 'fade-on'}`}></div>
                    {props.lang !== 'fr' ? <h2>Produce <Icon type="plus-inverted" /></h2>
                    : <h2>Garnitures et <br />accompagnements <Icon type="plus-inverted" /></h2>}
                   <img src={imgOurProduceDesk} alt="background produce" /> 
                </button>

                <button className={`ingredient-option ${isDrinks && 'is-active'}`} onClick={() => handleOptionClick('drinks')} disabled={fadeLayer && !isDrinks ? true : false}>
                    <div className={`fade-layer ${fadeLayer && 'fade-on'}`}></div>
                    {props.lang !== 'fr' ? <h2>Drinks <Icon type="plus-inverted" /></h2>
                    : <h2>Boissons <Icon type="plus-inverted" /></h2>}
                    <img src={imgOurDrinksDesk} alt="background drinks" />
                </button>

            </div>
            
            {/* style={{height: this.state.activeItem === 1 ? currentHeight : '0' +'px'}} */}
            <div ref={foodOptions} className="blockwrap ingredients-info">

                <div className={`options protein`}  style={{height: fadeLayer && isProtein ? currentHeight : '0px'}} >

                    <div ref={refProtein1} className="row">
                        <Link to={`/${props.lang}/our-values/our-food/beef`} className="page-link">
                            <img src={imgOurBeef} alt="" />
                            {props.lang !== 'fr' ? 
                                <h2><span>Our</span><br /> Beef</h2>
                                :
                                <h2><span>Notre</span><br /> Bœuf</h2>
                            }
                        </Link>
                    
                        <Link to={`/${props.lang}/our-values/our-food/chicken`} className="page-link">
                            {props.lang !== 'fr' ? 
                                <h2><span>Our</span><br /> Chicken</h2>
                                :
                                <h2><span>Notre</span><br /> Poulet</h2>
                            }
                            <img src={imgOurChicken} alt="" />
                        </Link>
                    
                        <Link to={`/${props.lang}/our-values/our-food/eggs`} className="page-link">
                            {props.lang !== 'fr' ? 
                                <h2><span>Our</span><br /> Eggs</h2>
                                :
                                <h2><span>Nos</span><br /> Œufs</h2>
                            }
                            <img src={imgOurEggs} alt="" />
                        </Link>
                    </div>

                    <div ref={refProtein2} className="row fifty">
                        <Link to={`/${props.lang}/our-values/our-food/pork`} className="page-link">
                            {props.lang !== 'fr' ? 
                                <h2><span>Our</span><br /> Pork</h2>
                                :
                                <h2><span>Notre</span><br /> Porc</h2>
                            }
                            <img src={imgOurPork} alt="" />
                        </Link>
                    
                        <Link to={`/${props.lang}/our-values/our-food/beyond-meat`} className="page-link">
                            {props.lang !== 'fr' ? 
                                <h2>Beyond Meat</h2>
                                :
                                <h2>Beyond Meat<sup className="menu-dagger">†</sup></h2>
                            }
                            <img src={imgOurBeyondMeat} alt="" />
                        </Link>
                    
                    
                    </div>

                </div>

                <div className="options produce"  style={{height: fadeLayer && isProduce ? currentHeight : '0px'}} >
                    <Link  ref={refProduce} to={`/${props.lang}/our-values/our-food/tomatoes`} className="page-link">
                        {props.lang !== 'fr' ? 
                            <h2><span>Our</span><br /> Tomatoes</h2>
                            :
                            <h2><span>Nos</span><br /> Tomates</h2>
                        }
                        <img src={imgOurTomatoes} alt="Our tomatoes" />
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/onions`} className="page-link">
                        {props.lang !== 'fr' ? 
                            <h2><span>Our</span><br /> Onions</h2>
                            :
                            <h2><span>Nos</span><br /> Oignons</h2>
                        }
                        <img src={imgOurOnions} alt="Our Onions" />
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/lettuce`}  className="page-link">
                        {props.lang !== 'fr' ? 
                            <h2><span>Our</span><br /> Lettuce</h2>
                            :
                            <h2><span>Notre</span><br /> Laitue</h2>
                        }
                        <img src={imgOurLettuce} alt="Our Lettuce" />
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/cheese`} className="page-link">
                        {props.lang !== 'fr' ? 
                            <h2><span>Our</span><br /> Cheese</h2>
                            :
                            <h2><span>Notre</span><br /> Fromage</h2>
                        }
                        <img src={imgOurCheese} alt="Our Cheese" />
                    </Link>
                </div>

                <div className="options drinks"  style={{height: fadeLayer && isDrinks ? currentHeight : '0px'}} >

                    <div className="row fifty">
                        <Link  ref={refDrinks} to={`/${props.lang}/our-values/our-food/rootbeer`} className="page-link">
                            {props.lang !== 'fr' ? 
                                <h2><span>Our</span><br /> Root beer</h2>
                                :
                                <h2><span>Notre</span><br /> Root beer</h2>
                            }
                            <img src={imgOurRootBeer} alt="Our tomatoes" />
                        </Link>
                        <Link to={`/${props.lang}/our-values/our-food/coffee`} className="page-link">
                            {props.lang !== 'fr' ? 
                                <h2><span>Our</span><br /> Coffee</h2>
                                :
                                <h2><span>Notre</span><br /> Café</h2>
                            }
                            <img src={imgOurCoffee} alt="Our Onions" />
                        </Link>
                    </div>
                    
                </div>

                    
            </div>


            <div className={`blockwrap options-wrap options-wrap-full our-food-pages`} >
                <Link to={`/${props.lang}/our-values/our-food/animal-welfare`} className={`ingredient-option ${isAnimalWelfare && 'is-active'} ${fadeLayer && !isAnimalWelfare ? 'disabled-link' : ''}`}>
                    <div className={`fade-layer ${fadeLayer && 'fade-on'}`}></div>
                    <h2>{props.lang !== 'fr' ? 'Animal Welfare' : 'Bien-être animal'} <Icon type="plus-inverted" /></h2>
                    {props.isDesktop ? <img src={imgAnimalWelfareDesk} alt="background drinks" /> : <img src={imgAnimalWelfare} alt="background drinks" /> }
                </Link>
            </div>

        </>

    )
}
export default Desktop;